<template>
    <div>
        <!-- 页面标题 -->
        <div class="page-header">
            <div class="line"></div>
            <div class="page-title">我的订单</div>
        </div>
        <!-- 搜索区域 -->
        <div class="search-section">
            <el-form :inline="true" :model="searchForm" class="search-form">
                <div>
                    <el-form-item label="订单编号" class="form-item-order-id">
                        <el-input v-model="order_sn" placeholder="请输入" size="small"></el-input>
                    </el-form-item>

                    <!-- <el-form-item label="订单状态" class="form-item-status">
                    <el-input v-model="searchForm.status" placeholder="请输入" size="small"></el-input>
                </el-form-item> -->

                    <!-- <el-form-item label="下单时间" class="form-item-date">
                        <el-date-picker v-model="searchForm.dateRange" type="daterange" range-separator="至"
                            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd" size="small"
                            :default-value="[new Date('2017-08-08'), new Date('2017-08-08')]"></el-date-picker>
                    </el-form-item> -->
                </div>

                <div>
                    <el-form-item class="form-item-reset">
                        <el-button type="default" size="small" @click="resetSearch">重置</el-button>
                    </el-form-item>

                    <el-form-item class="form-item-search">
                        <el-button type="primary" size="small" @click="searchOrders">查询</el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <!-- 订单状态标签 -->
        <div class="status-tabs">
            <el-radio-group v-model="activeStatus" size="small" class="status-radio-group">
                <el-radio-button label="all">全部</el-radio-button>
                <el-radio-button label="unpay">待支付</el-radio-button>
                <el-radio-button label="unship">待发货</el-radio-button>
                <el-radio-button label="unreceive">待收货</el-radio-button>
                <el-radio-button label="finish">待评价</el-radio-button>
                <el-radio-button label="6">售后/退款</el-radio-button>
            </el-radio-group>
        </div>

        <!-- 订单表格 -->
        <el-table :data="orderData" :border="true" style="width: 100%" class="order-table" v-if="activeStatus != '6'">
            <!-- 商品信息列 - 使用模板显示复杂内容 -->
            <el-table-column label="商品信息" width="400">
                <template slot-scope="scope">
                    <div class="order-info">
                        <!-- <div class="order-time">{{ scope.row.orderTime }}</div> -->
                        <div class="order-meta">
                            <span class="order-number">订单编号: {{ scope.row.order_sn }}</span>
                            <div style="display: flex; align-items: center; ">
                                <img :src="scope.row.shop_info.store_logo" alt="店铺头像"
                                    style="width: 20px; height: 20px; border-radius: 50%; margin-right: 10px; object-fit: cover;"
                                    v-if="scope.row.shop_info">
                                <span class="shop-name" v-if="scope.row.shop_info">{{ scope.row.shop_info.store_name
                                }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="goods-info" v-for="(item) in scope.row.goods">
                        <img :src="item.goods_thumb" alt="商品图片" class="goods-image">
                        <div class="goods-details">
                            <div class="goods-name">{{ item.goods_name }}</div>
                            <div class="goods-spec">{{ item.sku_name }}</div>
                        </div>
                        <div class="goods-quantity">x{{ item.num }}</div>

                    </div>
                </template>
            </el-table-column>

            <!-- 数量列 -->
            <!-- <el-table-column label="数量" width="100">
                <template slot-scope="scope">{{ scope.row.quantity }}</template>
            </el-table-column> -->

            <!-- 商品操作列 -->
            <el-table-column label="商品操作" width="120">
                <template slot-scope="scope">
                    <el-button type="text" size="small" class="text-btn apply-after-sales"
                        v-if="scope.row.btn_list && scope.row.btn_list.apply_refund == '1'"
                        @click="handleOrderDetail(scope.row)">
                        申请售后
                    </el-button>
                </template>
            </el-table-column>

            <!-- 金额列 -->
            <el-table-column label="金额" width="150">
                <template slot-scope="scope">
                    <!-- <div class="amount-label">{{ scope.row.amountLabel }}:</div> -->
                    <div class="amount-value">￥{{ scope.row.order_money }}</div>
                </template>
            </el-table-column>

            <!-- 状态列 -->
            <el-table-column label="状态" width="150">
                <template slot-scope="scope">
                    <div class="status-content">
                        <div class="status-text" v-if="scope.row.status == 0">待付款</div>
                        <div class="status-text" v-else-if="scope.row.status == 1">待发货</div>
                        <div class="status-text" v-else-if="scope.row.status == 2">待收货</div>
                        <div class="status-text" v-else-if="scope.row.status == 3">待评价</div>
                        <div class="status-text" v-else-if="scope.row.status == 4">交易成功</div>
                        <div class="status-text"
                            v-else-if="scope.row.status == 6 || scope.row.status == -1 || scope.row.status == -2">交易关闭
                        </div>

                        <el-button type="text" size="small" class="text-btn"
                            @click="handleOrderDetail(scope.row)">订单详情</el-button>

                    </div>
                </template>
            </el-table-column>

            <!-- 交易操作列 -->
            <el-table-column label="交易操作" width="200">
                <template slot-scope="scope">
                    <div class="trade-buttons">
                        <!-- 待支付状态 -->
                        <el-button type="primary" size="small" class="primary-btn"
                            v-if="scope.row.btn_list && scope.row.btn_list.go_pay == '1'"
                            @click="handlePay(scope.row)">去支付</el-button>

                        <el-button size="small" class="default-btn"
                            v-if="scope.row.btn_list && scope.row.btn_list.cancel_order == '1'"
                            @click="openCancelOrderDialog(scope.row)">取消订单</el-button>

                        <!-- 待发货状态 -->
                        <el-button type="primary" size="small" class="primary-btn"
                            v-if="scope.row.btn_list && scope.row.btn_list.remind_send == '1' && scope.row.btn_list.remind_already != '1'"
                            @click="handleRemindDelivery(scope.row)">提醒发货</el-button>

                        <el-button type="primary" size="small" class="primary-btn" disabled
                            v-else-if="scope.row.btn_list && scope.row.btn_list.remind_already == '1'">已提醒</el-button>

                        <!-- 待收货状态 -->
                        <el-button type="primary" size="small" class="primary-btn" style="margin-left: 0px"
                            v-if="scope.row.btn_list && scope.row.btn_list.confirm_receive == '1'"
                            @click="confirmReceipt(scope.row)">确认收货</el-button>

                        <el-button type="primary" size="small" class="primary-btn" style="margin-left: 0px"
                            v-if="scope.row.btn_list && scope.row.btn_list.evaluate == '1'"
                            @click="goPingjia(scope.row)">去评价</el-button>

                        <el-button type="text" size="small" class="text-btn" style="margin-left: 0px"
                            v-if="scope.row.btn_list && scope.row.btn_list.view_logistics == '1'"
                            @click="openLogisticsDialog(scope.row)">查看物流</el-button>

                        <!-- 待评价状态 -->
                        <!-- <el-button type="text" size="small" class="text-btn">再次购买</el-button> -->

                        <!-- <el-button type="text" size="small" class="text-btn" style="margin-left: 0px" >订单详情</el-button> -->

                        <el-button type="text" size="small" class="text-btn" style="color: #666666;margin-left: 0px"
                            v-if="scope.row.status == 4 || scope.row.status == 5 || scope.row.status == -2 || scope.row.status == -1"
                            @click="handleDeleteOrder(scope.row)">删除订单</el-button>

                    </div>
                </template>
            </el-table-column>
        </el-table>


        <!-- 订单表格 -->
        <el-table :data="orderData" :border="true" style="width: 100%" class="order-table" v-else>
            <!-- 商品信息列 - 使用模板显示复杂内容 -->
            <el-table-column label="商品信息" width="400">
                <template slot-scope="scope">
                    <div class="order-info">
                        <!-- <div class="order-time">{{ scope.row.orderTime }}</div> -->
                        <div class="order-meta">
                            <div class="tuikuanTips" v-if="scope.row.refund_type == '1'">退款</div>
                            <div class="tuikuanTips" v-if="scope.row.refund_type == '2'">退货退款</div>
                            <div class="tuihuoTips" v-if="scope.row.refund_type == '3'">换货</div>
                            <span class="order-number">订单编号: {{ scope.row.order_sn }}</span>
                            <!-- <div style="display: flex; align-items: center; ">
                                <img :src="scope.row.shop_info.store_logo" alt="店铺头像"
                                    style="width: 20px; height: 20px; border-radius: 50%; margin-right: 10px; object-fit: cover;"
                                    v-if="scope.row.shop_info">
                                <span class="shop-name" v-if="scope.row.shop_info">{{ scope.row.shop_info.store_name
                                }}</span>
                            </div> -->
                        </div>
                    </div>
                    <div class="goods-info">
                        <img :src="scope.row.goods_thumb" alt="商品图片" class="goods-image">
                        <div class="goods-details">
                            <div class="goods-name">{{ scope.row.goods_name }}</div>
                            <div class="goods-spec">{{ scope.row.sku_name }}</div>
                        </div>
                        <div class="goods-quantity">x{{ scope.row.num }}</div>

                    </div>
                </template>
            </el-table-column>

            <!-- 数量列 -->
            <!-- <el-table-column label="数量" width="100">
                <template slot-scope="scope">{{ scope.row.quantity }}</template>
            </el-table-column> -->

            <!-- 商品操作列 -->
            <el-table-column label="商品操作" width="120">
                <template slot-scope="scope">
                    <el-button type="text" size="small" class="text-btn apply-after-sales"
                        v-if="scope.row.btn_list && scope.row.btn_list.apply_refund == '1'"
                        @click="handleOrderDetail(scope.row)">
                        申请售后
                    </el-button>
                </template>
            </el-table-column>

            <!-- 金额列 -->
            <el-table-column label="金额" width="150">
                <template slot-scope="scope">
                    <!-- <div class="amount-label">{{ scope.row.amountLabel }}:</div> -->
                    <div class="amount-value">￥{{ scope.row.refund_money }}</div>
                </template>
            </el-table-column>

            <!-- 状态列 -->
            <el-table-column label="状态" width="150">
                <template slot-scope="scope">
                    <div class="status-content" v-if="scope.row.refund_type == '1' || scope.row.refund_type == '2'">
                        <div class="status-text" v-if="scope.row.status == '0'">待审核</div>

                        <div class="status-text" v-if="scope.row.status == '1' && scope.row.express_no == ''">待寄回</div>
                        <div class="status-text" v-else-if="scope.row.status == 2">待退款</div>
                        <div class="status-text" v-else-if="scope.row.status == 3">商家已收货</div>
                        <div class="status-text" v-else-if="scope.row.status == 4">售后已完成</div>
                        <div class="status-text" v-else-if="scope.row.status < 0">售后关闭</div>
                        <div class="status-text" v-else-if="scope.row.status == '1' && scope.row.express_no != ''">待退款
                        </div>

                        <el-button type="text" size="small" class="text-btn"
                            @click="handleShouhouDetail(scope.row)">订单详情</el-button>
                    </div>

                    <div class="status-content" v-if="scope.row.refund_type == '3'">
                        <div class="status-text" v-if="scope.row.status == '0'">待审核</div>
                        <div class="status-text" v-if="scope.row.status == '1' && scope.row.express_no == ''">待寄回</div>
                        <div class="status-text" v-else-if="scope.row.status == '1' && scope.row.express_no != ''">待收货
                        </div>
                        <div class="status-text" v-else-if="scope.row.status == 2">待发货</div>
                        <div class="status-text" v-else-if="scope.row.status == 4">已发货</div>
                        <div class="status-text" v-else-if="scope.row.status < 0">售后关闭</div>

                        <el-button type="text" size="small" class="text-btn"
                            @click="handleOrderDetail(scope.row)">订单详情</el-button>
                    </div>

                </template>
            </el-table-column>

            <!-- 交易操作列 -->
            <el-table-column label="交易操作" width="200">
                <template slot-scope="scope">
                    <div class="trade-buttons">
                        <!-- 待支付状态 -->
                        <el-button size="small" class="default-btn" @click="chexiaoCancelOrder(scope.row)"
                            v-if="(scope.row.status == '0' || scope.row.status == '1') && scope.row.express_no == ''">撤销申请</el-button>

                        <el-button type="text" size="small" class="text-btn" style="margin-left: 0px"
                            v-if="scope.row.status == '2' && scope.row.refund_type == '2'"
                            @click="openLogisticsDialog(scope.row, 2)">查看物流</el-button>

                        <!-- <el-button type="text" size="small" class="text-btn" style="margin-left: 0px"
                            v-if="scope.row.status == '1' && scope.row.refund_type == '1'"
                            @click="openLogisticsDialog(scope.row)">寄回信息</el-button> -->

                        <el-button type="text" size="small" class="text-btn" style="color: #666666;margin-left: 0px"
                            v-if="scope.row.status <= '0' || scope.row.status >= '4'"
                            @click="handleDeleteRefundOrder(scope.row)">删除订单</el-button>

                    </div>
                </template>
            </el-table-column>
        </el-table>


        <!-- 分页控件 -->
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="totalOrders">
            </el-pagination>
        </div>


        <!-- 取消订单原因弹窗 -->
        <el-dialog title="请选择取消原因" :visible.sync="cancelOrderDialogVisible" width="520px" :close-on-click-modal="false"
            :show-close="true" center>
            <el-radio-group v-model="selectedCancelReason" class="cancel-reason-group">
                <div v-for="reason in cancelReasons" :key="reason.aid" class="reason-item">
                    <span class="reason-text">{{ reason.reason }}</span>
                    <el-radio :label="reason.aid" class="reason-radio"></el-radio>
                </div>
            </el-radio-group>
            <span slot="footer" class="dialog-footer">
                <el-button @click="cancelOrderDialogVisible = false">暂不取消</el-button>
                <el-button type="primary" style="background-color: #286CED;"
                    @click="confirmCancelOrder">确定取消</el-button>
            </span>
        </el-dialog>

        <el-dialog title="物流信息" :visible.sync="logisticsVisible" width="60%" center>
            <ViewLogistics v-if="orderInfo.aid" :orderId="orderInfo.aid" :isAfter="false" :isShouhou="isShouhou" />
        </el-dialog>

    </div>
</template>

<script>
import ViewLogistics from '@/components/ViewLogistics.vue'

export default {
    name: 'OrderList',
    components: {
        ViewLogistics
    },
    data() {
        return {
            searchForm: {
                orderId: '',
                status: '',
                dateRange: ['', '']
            },

            // 分页数据
            currentPage: 1,
            pageSize: 10,
            totalOrders: 0,


            order_sn: '',

            // 取消订单弹窗相关
            cancelOrderDialogVisible: false,
            selectedCancelReason: '',
            currentOrder: null,
            cancelId: '',
            // 取消订单原因列表
            cancelReasons: [],

            activeStatus: 'all',
            // 订单数据 - 模拟实际订单数据结构
            orderData: [],

            logisticsVisible: false,
            // 订单详情
            orderInfo: {}
        }
    },

    watch: {
        activeStatus(newVal, oldVal) {
            if (newVal != '6') {
                this.getOrderList();
            } else if (newVal == '6') {
                // 获取售后列表
                this.getRefundList();
            }
        }
    },

    created() {
        this.getOrderList();
        this.getCancelOrderReasons()
    },
    mounted() {
    },
    methods: {
        resetSearch() {
            this.order_sn = '';
            this.getOrderList()

        },

        searchOrders() {
            if (this.activeStatus == 6) {
                this.getRefundList();
            } else {
                this.getOrderList()
            }
        },

        // 去支付
        handlePay(order) {
            this.$router.push({
                name: 'purchase', // 用 name 跳转，而非 path
                params: {
                    id: order.goods_id,
                    totalPrice: order.payable_money,
                    selectedSkus: order.goods // 直接传对象/数组
                },
                // 如需保留 query 参数，可加 query
                query: { id: order.goods_id }
            });
        },

        // 打开物流弹窗
        openLogisticsDialog(order, type) {
            // 2是售后订单
            if (type == 2) {
                this.isShouhou = true
            } else {
                this.isShouhou = false
            }
            this.orderInfo = order;
            this.logisticsVisible = true;
        },

        // 跳转评价页面
        goPingjia(order) {
            this.$router.push({
                path: '/FabuEvaluate',
                query: {
                    orderId: order.aid
                }
            })
        },

        // 跳转售后页面
        goShouhou(order) {
            this.$router.push({
                path: '/ShenqingShouhou',
                query: {
                    orderId: order.aid
                }
            })
        },


        // 处理提醒发货
        handleRemindDelivery(order) {
            this.$api.remindDelivery({ order_id: order.aid }).then(res => {
                this.$message.success('提醒发货成功');
                this.getOrderList(); // 重新获取订单列表
            }).catch(err => {
                this.$message.error(err || '提醒发货失败');
            });
        },
        // 确认收货
        confirmReceipt(order) {
            this.$confirm('确定要确认收货吗？', '确认收货', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$api.confirmReceipt({ order_id: order.aid }).then(res => {
                    this.$message.success('确认收货成功');
                    this.getOrderList(); // 重新获取订单列表
                }).catch(err => {
                    this.$message.error(err || '确认收货失败');
                });
            }).catch(() => {
                this.$message.info('已取消确认收货');
            });
        },
        // 处理删除订单
        handleDeleteOrder(order) {
            this.$confirm('确定要删除此订单吗？', '删除订单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteOrder(order.aid);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 删除订单
        deleteOrder(orderId) {
            this.$api.deleteOrder({ order_id: orderId }).then(res => {
                this.$message.success('订单删除成功');
                this.getOrderList(); // 重新获取订单列表
            }).catch(err => {
                this.$message.error(err || '删除订单失败');
            });
        },

        // 处理删除售后订单
        handleDeleteRefundOrder(order) {
            this.$confirm('确定要删除此售后订单吗？', '删除售后订单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteRefundOrder(order.aid);
            }).catch(() => {
                this.$message.info('已取消删除');
            });
        },

        // 删除售后订单
        deleteRefundOrder(orderId) {
            this.$api.deleteRefundOrder({ id: orderId }).then(res => {
                this.$message.success('售后订单删除成功');
                this.getRefundList(); // 重新获取售后订单列表
            }).catch(err => {
                this.$message.error(err || '删除售后订单失败');
            });
        },

        // 打开取消订单弹窗
        openCancelOrderDialog(order) {
            this.currentOrder = order;
            this.cancelId = order.aid;
            this.cancelOrderDialogVisible = true;
            this.selectedCancelReason = this.cancelReasons[0].aid || '';
        },

        // 确认取消订单
        confirmCancelOrder() {
            console.log(this.selectedCancelReason);

            if (!this.currentOrder) return;

            let data = {
                order_id: this.cancelId,
                return_id: this.selectedCancelReason
            };

            this.$api.cancelOrder(data).then(res => {
                this.$message.success('订单取消成功');
                this.cancelOrderDialogVisible = false;
                this.getOrderList(); // 重新获取订单列表
            }).catch(err => {
                this.$message.error(err || '取消订单失败');
            });
        },

        // 撤销售后申请
        chexiaoCancelOrder(order) {
            let data = {
                id: order.aid,
            };
            this.$api.cancelRefund(data).then(res => {
                this.$message.success('售后申请撤销成功');
                this.cancelOrderDialogVisible = false;
                this.getRefundList(); // 重新获取订单详情
            }).catch(err => {
                this.$message.error(err || '售后申请撤销失败');
            });
        },

        // 获取订单取消原因列表
        getCancelOrderReasons() {
            let data = {
                type: '2',
                list_rows: '10'
            }
            this.$api.getCancelOrderReasons(data).then(res => {
                this.cancelReasons = res || [];
                this.selectedCancelReason = res[0].aid || '';
            }).catch(err => {
                this.$message.error(err);
            })
        },

        //获取订单列表
        getOrderList() {
            let data = {
                page: this.currentPage,
                list_rows: this.pageSize,
                type: this.activeStatus,
                order_sn: this.order_sn
            }
            this.$api.getOrderList(data).then(res => {
                this.orderData = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 获取售后列表
        getRefundList() {
            let data = {
                page: this.currentPage,
                list_rows: this.pageSize,
                order_sn: this.order_sn
            }
            this.$api.getRefundList(data).then(res => {
                this.orderData = res.data || [];
                this.totalOrders = res.total || 0;
            }).catch(err => {
                this.$message.error(err);
            })
        },

        // 跳转订单详情
        handleOrderDetail(order) {
            console.log(order);
            this.$parent.currentComponent = 'OrdersDetail';
            this.$parent.componentParams = { orderId: order.aid };
        },
        // 跳转售后详情
        handleShouhouDetail(order) {
            console.log(order);
            this.$parent.currentComponent = 'ShouhouDetail';
            this.$parent.componentParams = { orderId: order.aid };
        },



        // 分页方法
        handleSizeChange(val) {
            this.pageSize = val;
            this.getOrderList();
        },
        handleCurrentChange(val) {
            this.currentPage = val;
            this.getOrderList();
        },

    }
}
</script>

<style scoped>
/* 原有样式保持不变 */
.my-orders-container {
    background-color: #fff;
    border-radius: 8px;
    margin: 0 auto;
    padding: 20px;
}

/* 页面标题 */
.page-header {
    margin-bottom: 20px;
    display: flex;
    align-items: center;
}

.page-title {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 0;
    padding-left: 10px;
    text-align: left;
}

.line {
    width: 3px;
    height: 18px;
    background-color: #286CED;
}

/* 搜索区域 */
.search-section {
    background-color: #f5f7fa;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
}

.search-form {
    margin: 0;
    display: flex;
    flex-wrap: nowrap;
    align-items: end;
    gap: 10px;
    /* justify-content: space-between; */
}

/* 为每个表单项目设置固定宽度 */
.form-item-order-id {
    width: 200px;
    text-align: left;
}

.form-item-status {
    width: 200px;
    text-align: left;
}

.form-item-date {
    width: 300px;
    text-align: left;
}

/* 确保输入框和日期选择器占满表单项目宽度 */
.search-form .el-input,
.search-form .el-date-editor {
    width: 100%;
}

/* 订单状态标签 */
.status-tabs {
    margin-bottom: 20px;
}

.status-radio-group {
    display: flex;
    align-items: center;
}

::v-deep .el-radio-button__original-radio:checked+.el-radio-button__inner {
    background-color: #286CED;
    border-color: #286CED;
}

/* 表格自定义样式 */
.order-table {
    border-radius: 8px;
    overflow: hidden;
}

/* 商品信息样式 */
.goods-info {
    display: flex;
    align-items: center;
    padding: 10px 0;
}

.goods-image {
    width: 80px;
    height: 80px;
    object-fit: cover;
    border: 1px solid #e8e8e8;
    margin-right: 15px;
}

.goods-details {
    flex: 1;
}

.goods-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
    line-height: 1.4;
}

.goods-spec {
    font-size: 12px;
    color: #999;
}

/* 订单信息样式 */
.order-info {
    margin-bottom: 10px;
}

.order-time {
    font-size: 14px;
    color: #666;
    margin-bottom: 5px;
}

.order-meta {
    display: flex;
    gap: 20px;
    font-size: 14px;
    color: #666;

}

.tuikuanTips {
    font-size: 10px;
    color: #F02325;
    white-space: nowrap;
}

.tuihuoTips {
    font-size: 10px;
    color: #3F9529;
    white-space: nowrap;
}

/* 金额样式 */
.amount-label {
    font-size: 12px;
    color: #999;
    margin-bottom: 3px;
}

.amount-value {
    font-size: 14px;
    color: #333;
    font-weight: 500;
}

/* 状态样式 */
.status-content {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.status-text {
    font-size: 14px;
    color: #333;
    margin-bottom: 5px;
}

.status-countdown {
    font-size: 12px;
    color: #286CED;
}

/* 交易操作按钮样式 */
.trade-buttons {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: center;
}

/* 按钮样式 */
.primary-btn {
    background-color: #286CED;
    border-color: #286CED;
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.default-btn {
    border-radius: 4px;
    padding: 4px 12px;
    font-size: 12px;
}

.text-btn {
    font-size: 12px;
    color: #286CED;
    padding: 4px 0;
}

.apply-after-sales {
    color: #286CED;
    text-align: center;
    width: 100%;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .trade-buttons {
        flex-direction: row;
        flex-wrap: wrap;
        gap: 8px;
        justify-content: center;
    }
}

/* 分页容器 */
.pagination-container {
    background-color: #ffffff;
    border-radius: 8px;
    padding: 20px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.05);
    text-align: right;
    text-align: center;

}

/* 取消订单弹窗样式 */
.cancel-reason-group {
    display: flex;
    flex-direction: column;
    gap: 15px;
    margin-top: 20px;
}

.reason-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: #333;
    padding: 5px 0;
}

.reason-text {
    text-align: left;
}

.reason-radio {
    text-align: right;
}

/* 隐藏radio组件的默认文本 */
::v-deep .reason-radio .el-radio__label {
    display: none;
}

.dialog-footer {
    display: flex;
    justify-content: center;
    gap: 20px;
}
</style>